import {AxiosError} from 'axios';

const getErrorCodeFromResponse = (error: AxiosError): string => {
    return (error.response.data && error.response.data.errorCode) || '';
};

export default getErrorCodeFromResponse;
